export default {
  state: {
    token: localStorage.getItem('token') || '',
    user: localStorage.getItem('token') ? JSON.parse(atob(localStorage.getItem('token').split('.')[1])).user : {} || {},
    permisos: localStorage.getItem('permisos')
      ? JSON.parse(localStorage.getItem('permisos'))
      : [],
    auth_request: false,
    cambiar_clave: null
  },
  getters: {
    isAuthenticated: state => !!state.token,
    auth_request: state => state.auth_request,
    token: state => state.token,
    cambiar_clave: state => state.cambiar_clave,
    user: state => state.user
  },
  mutations: {
    AUTH_REQUEST: (state, payload) => (state.auth_request = payload),
    AUTH: (state, payload) => (state.isAuthenticated = payload),
    SET_USER: (state, payload) => (state.user = payload),
    AUTH_SUCCESS: (state, payload) => (state.token = payload),
    PERMISOS: (state, payload) => (state.permisos = payload),
    SET_CAMBIAR_CLAVE: (state, payload) => (state.cambiar_clave = payload)
  },
  actions: {
    login ({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST', true)
        this.state.api
          .post('login', user)
          .then(async response => {
            commit('AUTH', true)
            const token = response.data.access_token
            commit('SET_USER', JSON.parse(atob(token.split('.')[1])).user)
            localStorage.setItem('token', token)
            const permisos = response.data.permisos
            commit('PERMISOS', permisos)
            localStorage.setItem('permisos', JSON.stringify(permisos))
            this.state.api.defaults.headers.common['Authorization'] =
              'Bearer ' + token
            commit('AUTH_SUCCESS', token)
            commit(
              'SET_CAMBIAR_CLAVE',
              response.data.cambiar_clave ? response.data.cambiar_clave : false
            )
            resolve(response)
            try{

              var axios = require("axios");
              let request = await axios.post("https://sigapi.fga.com.co/api/auth/login",{
                  "username":user.username,
                  "password":user.password
              })
              localStorage.setItem('tokenGateway', request.data.access_token);
            }catch(err){
              console.log('err -- tokenGateway',err);
            }
          })
          .catch(err => {
            localStorage.removeItem('token')
            reject(err)
          })
          .then(() => {
            commit('AUTH_REQUEST', false)
          })
      })
    },
    logout ({ commit }) {
      return new Promise(resolve => {
        commit('AUTH', false)
        commit('SET_USER', null)
        //localStorage.removeItem('token')
        //localStorage.removeItem('permisos')
        localStorage.clear()
        delete this.state.api.defaults.headers.common['Authorization']
        resolve()
      })
    },
    me ({ commit }, payload) {
      this.dispatch('index', payload)
        .then()
        .catch()
    },
    recuperarpassword ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST', true)
        this.state.api
          .get('recuperar_password', { params: payload })
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .then(() => {
            commit('AUTH_REQUEST', false)
          })
      })
    }
  }
}
